import * as React from 'react';
import { DirectionalArrow, ARROW_DIRECTION } from '@estee/elc-icons';
import styled, { css } from 'styled-components';
import * as classnames from 'classnames';

export interface ISliderArrowProps {
    className?: string;
    onClick?(): void;
    direction?: string;
    title?: string;
}

export interface IIconWrapperContentProps {
    direction?: string;
}

const IconWrapper = styled.div<IIconWrapperContentProps & React.HTMLProps<HTMLInputElement>>`
    position: absolute;
    padding: 0;
    height: auto;
    width: auto;
    cursor: pointer;

    ${props =>
        props.direction === ARROW_DIRECTION.LEFT_DIRECTION &&
        css`
            top: 50%;
            left: -15px;
        `}

    ${props =>
        props.direction === ARROW_DIRECTION.RIGHT_DIRECTION &&
        css`
            top: 50%;
            right: -15px;
        `}

    ${props =>
        props.direction === ARROW_DIRECTION.TOP_DIRECTION &&
        css`
            bottom: auto;
            right: 43%;
            top: -10px;
        `}

    ${props =>
        props.direction === ARROW_DIRECTION.BOTTOM_DIRECTION &&
        css`
            top: auto;
            bottom: -10px;
            right: 40%;
        `}
`;

export const SliderArrow = (props: ISliderArrowProps) => {
    const { className, direction, title, onClick } = props;

    const sliderArrowWrapperClassNames = classnames(
        'elc-slider-arrow-wrapper',
        'js-slider-arrow-wrapper',
        className
    );

    const sliderArrowClassNames = classnames(`elc-slider-arrow-${direction}`);

    const handleKeypress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter' || event.key === ' ') {
            if (onClick) {
                onClick();
            }
        }
    };

    return (
        <IconWrapper
            className={sliderArrowWrapperClassNames}
            onClick={onClick}
            direction={direction}
            role={'button'}
            tabIndex={0}
            onKeyPress={handleKeypress}
            aria-label={title}
        >
            <DirectionalArrow direction={direction} className={sliderArrowClassNames} />
        </IconWrapper>
    );
};
